/* The purpose of the exported hash() function is to convert JS values into a
 * unique string, so that they can be used as an object key. This means that:
 *
 *  - {1:2, 2:1} should hash to the same value as {2:1, 1:2}; i.e. key ordering
 *    should not matter
 *
 *  - Key collisions should not happen in practice (XXX read below)
 *
 *  - Keys are not guaranteed to be stable across versions, so never store keys
 *    outside of the run-time environment (so never store these hashes in our
 *    databases, for instance); {1:2} might hash to a different value in the
 *    future.
 *
 * The code was stolen/imported/modified from
 * https://github.com/bevacqua/hash-sum - I could've imported the hash-sum
 * package directly, but the actual hash algorithm (in fold()) looks somewhat
 * janky, so I'd rather keep the code here where it can be improved/replaced if
 * necessary. (Besides, it's not the biggest of packages, so the bad-practice
 * debt is negligible)
 *
 * Regarding the hash-algorithm jankyness;
 *
 *  - The output is only 32-bit, so even assuming high-quality output, we'd
 *    still run into serious birthday paradox collision problems after a few
 *    1000 keys (probability of collision is 1% at ~9k keys, 10% at ~30k keys,
 *    50% at ~77k keys, ...)
 *
 *  - ... and `hash = ((hash << 5) - hash) + chr` doesn't look like a
 *    high-quality hash algorithm to me :-) So the collision probabilities are
 *    probably even worse than what the birthday paradox would suggest!
 */

function pad(hash, len) {
	while (hash.length < len) {
		hash = '0' + hash;
	}
	return hash;
}

function fold(hash, text) {
	var i;
	var chr;
	var len;
	if (text.length === 0) {
		return hash;
	}
	for (i = 0, len = text.length; i < len; i++) {
		chr = text.charCodeAt(i);
		hash = ((hash << 5) - hash) + chr;
		hash |= 0;
	}
	return hash < 0 ? hash * -2 : hash;
}

function foldObject(hash, o, seen) {
	return Object.keys(o).sort().reduce(foldKey, hash);
	function foldKey (hash, key) {
		return foldValue(hash, o[key], key, seen);
	}
}

function foldValue(input, value, key, seen) {
	var hash = fold(fold(fold(input, key), toString(value)), typeof value);
	if (value === null) {
		return fold(hash, 'null');
	}
	if (value === undefined) {
		return fold(hash, 'undefined');
	}
	if (typeof value === 'object' || typeof value === 'function') {
		if (seen.indexOf(value) !== -1) {
			return fold(hash, '[Circular]' + key);
		}
		seen.push(value);

		var objHash = foldObject(hash, value, seen)

			if (!('valueOf' in value) || typeof value.valueOf !== 'function') {
				return objHash;
			}

		try {
			return fold(objHash, String(value.valueOf()))
		} catch (err) {
			return fold(objHash, '[valueOf exception]' + (err.stack || err.message))
		}
	}
	return fold(hash, value.toString());
}

function toString(o) {
	return Object.prototype.toString.call(o);
}

function hash(o) {
	return pad(foldValue(0, o, '', []).toString(16), 8);
}

module.exports = hash;



// WEBPACK FOOTER //
// ./src/hash.js